import { render, staticRenderFns } from "./CustomersPendingVerificationBatch.vue?vue&type=template&id=ff4137f4&"
import script from "./CustomersPendingVerificationBatch.vue?vue&type=script&lang=js&"
export * from "./CustomersPendingVerificationBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff4137f4')) {
      api.createRecord('ff4137f4', component.options)
    } else {
      api.reload('ff4137f4', component.options)
    }
    module.hot.accept("./CustomersPendingVerificationBatch.vue?vue&type=template&id=ff4137f4&", function () {
      api.rerender('ff4137f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomersPendingVerificationBatch.vue"
export default component.exports